import React, { FC } from 'react'
import profilePic from '../assets/profile-pic.jpg'

const Bio: FC = () => (
  <div className="authors">
    <div className="author-box">
      <img src={profilePic} alt={`Ayush Sharma`} className="author-profile-image" />
      <section className="author-box-content">
        <div className="author-box-label">Author</div>
        <h5 className="author-box-name">Anon</h5>

        <p>Written by Anon</p>
      </section>
    </div>
  </div>
)

export default Bio
